module.exports = __webpack_public_path__ + "img/empty.23eaa032.png";